import { logError } from 'errors/errorHandler';

import UserService from './services';
import UserTypes from './types';

import type IActionType from 'store/_utils/interfaces/IActionType';

export const listAffiliates = () => UserTypes.listAffiliates.createAction(() => UserService.listMyAffiliates());
export const listCoupons = () => UserTypes.listCoupons.createAction(() => UserService.listMyCoupons());
export const user = () => UserTypes.user.createAction(null, userAction);

const userAction = (actionType: IActionType) => async (dispatch: any) => {
  try {
    dispatch({ type: actionType.request });
    let { data } = await UserService.user();
    dispatch({ type: actionType.success, payload: data });
    dispatch({ type: UserTypes.originalUser.success, payload: data });
  } catch (error) {
    dispatch({ type: actionType.error, error });
    logError(error);
  }
};
